import React, { FC } from "react";

import { Grid } from "@mui/material";
import { useGetSitewideAnalytics } from "@src/api/analytics/get-sitewide-analytics";
import { BaseMetricSection } from "@src/features/analytics/baseDashboard/BaseMetricSection";
import { GraphIntervalButtons } from "@src/features/analytics/baseDashboard/chartComponents/GraphIntervalButtons";
import { SitewideAnalyticsProfitTable } from "@src/features/analytics/sitewideAnalytics/profitTable/SitewideAnalyticsProfitTable";
import { useDispatch, useSelector } from "@src/store";
import { updateSitewideDashboardFilter } from "@src/store/slices/sitewideDashboardFilters";
import { UseQueryResult } from "@tanstack/react-query";

const sitewideIntervals = [
  { value: "1 DAY", label: "Day", borderRadius: { left: true } },
  { value: "1 WEEK", label: "Week" },
  { value: "1 MONTH", label: "Month", borderRadius: { right: true } },
];

const ordersMatchedToSessionSelections = [
  { value: "allOrders", label: "All Orders" },
  { value: "ordersMatchedToSession", label: "Matched To Session" },
];

interface SitewideProfitPageProps {
  sitewideAnalyticsDataQuery: UseQueryResult<any>;
}

export const SitewideProfitPage = ({
  sitewideAnalyticsDataQuery,
}: SitewideProfitPageProps) => {
  const dispatch = useDispatch();
  const sitewideDashboardFilters = useSelector(
    (state) => state.sitewideDashboardFilters
  );

  const handleIntervalChange = (newInterval: string) => {
    dispatch(
      updateSitewideDashboardFilter({
        key: "interval",
        value: newInterval,
      })
    );
  };

  const handleOrdersMatchedToSessionChange = (newSelection: string) => {
    dispatch(
      updateSitewideDashboardFilter({
        key: "ordersMatchedToSession",
        value: newSelection,
      })
    );
  };

  return (
    <Grid item xs={12} mt={4}>
      <BaseMetricSection
        groupTitle={"Sitewide Profit"}
        rightSideButtons={[
          <GraphIntervalButtons
            key={"filter-buttons"}
            graphInterval={sitewideDashboardFilters.ordersMatchedToSession}
            hasNoData={false}
            isLoading={sitewideAnalyticsDataQuery.isLoading}
            setGraphInterval={handleOrdersMatchedToSessionChange}
            intervals={ordersMatchedToSessionSelections}
          />,
          <GraphIntervalButtons
            key={"filter-buttons"}
            graphInterval={sitewideDashboardFilters.interval}
            hasNoData={false}
            isLoading={sitewideAnalyticsDataQuery.isLoading}
            setGraphInterval={handleIntervalChange}
            intervals={sitewideIntervals}
          />,
        ]}
      >
        <Grid item xs={12} sx={{ width: "100%" }}>
          <SitewideAnalyticsProfitTable
            sitewideAnalyticsDataQuery={sitewideAnalyticsDataQuery}
          />
        </Grid>
      </BaseMetricSection>
    </Grid>
  );
};
